import { useReducer } from 'react';

const initialState = {
  sitesList: [],
};

const getSiteIndex = (siteId, state) => {
  const siteIndex = state.sitesList.findIndex((e) => e.site_id === siteId);
  if (siteIndex === -1) {
    throw new Error(`Provided site id (${siteId}) is invalid.`);
  }
  return siteIndex;
};

const getNewsletterIndex = (siteId, newsletterScheduleId, state) => {
  const siteIndex = getSiteIndex(siteId, state);
  const newsletterIndex = state.sitesList[siteIndex]
    .topic_newsletter_add_on_options
    .findIndex((e) => e.newsletter_schedule_id === newsletterScheduleId);
  if (newsletterIndex === -1) {
    throw new Error(`Provided newsletter schedule id (${newsletterScheduleId}) is invalid.`);
  }
  return newsletterIndex;
};

const setSiteSelected = (state, siteId, value) => {
  const siteIndex = getSiteIndex(siteId, state);
  const siteState = {
    ...state.sitesList[siteIndex],
    selected: value,
  };
  if (!value) {
    siteState.topic_newsletter_add_on_options = siteState
      .topic_newsletter_add_on_options
      .map((e) => {
        return {
          ...e,
          selected: false,
        };
      });
  }
  return [
    ...state.sitesList.slice(0, siteIndex),
    siteState,
    ...state.sitesList.slice(siteIndex + 1),
  ];
};

const setNewsletterSelected = (state, siteId, newsletterScheduleId, value) => {
  const siteIndex = getSiteIndex(siteId, state);
  const newsletterIndex = getNewsletterIndex(siteId, newsletterScheduleId, state);
  return [
    ...state.sitesList.slice(0, siteIndex),
    {
      ...state.sitesList[siteIndex],
      topic_newsletter_add_on_options: [
        ...state.sitesList[siteIndex].topic_newsletter_add_on_options.slice(0, newsletterIndex),
        {
          ...state.sitesList[siteIndex].topic_newsletter_add_on_options[newsletterIndex],
          selected: value,
        },
        ...state.sitesList[siteIndex].topic_newsletter_add_on_options.slice(newsletterIndex + 1),
      ],
    },
    ...state.sitesList.slice(siteIndex + 1),
  ];
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_SITES':
      return {
        ...state,
        sitesList: [...action.payload],
      };
    case 'ADD_SELECTED_SITE':
      return {
        ...state,
        sitesList: setSiteSelected(state, action.payload, true),
      };
    case 'REMOVE_SELECTED_SITE':
      return {
        ...state,
        sitesList: setSiteSelected(state, action.payload, false),
      };
    case 'ADD_ADDON':
      return {
        ...state,
        sitesList: setNewsletterSelected(
          state,
          action.payload.siteId,
          action.payload.newsletterScheduleId,
          true,
        ),
      };
    case 'REMOVE_ADDON':
      return {
        ...state,
        sitesList: setNewsletterSelected(
          state,
          action.payload.siteId,
          action.payload.newsletterScheduleId,
          false,
        ),
      };
    default:
      throw new Error(`Provided dispatch action (${action.type}) is invalid.`);
  }
};

const usePromoteSitesReducer = () => {
  return useReducer(reducer, initialState);
};

export default usePromoteSitesReducer;
